import React, { useState, useEffect } from 'react'
import {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody
} from '@coreui/react'
import { useDispatch, useSelector } from 'react-redux';
import { useQuery, useLazyQuery } from '@apollo/client';
import {  GET_ONE_FEDERAL_POLL_MAP, 
          GET_ONE_CANADIAN_ELECTION_CANDIDATES,
          GET_ONE_FEDERAL_ELECTION_MAP,
          GET_ONE_RIDING_INFO,
          GET_ONE_CANADIAN_ELECTION,
          GET_ALL_RELATED_CONTESTS
        } from '../../../../apollo/queries';
import { activeMap } from '../../../../apollo/cache'
import { TheAside, NearbyMaps } from '../../../../containers';
import { Helmet } from "react-helmet";
import { useRouteMatch } from "react-router-dom";
import WealthGraph from './WealthGraph';
import PopulationPyramid from './PopulationPyramid';
import ResidencePie from './ResidencePie';
import MapGL from '../../../../components/map/MapGL';
import ReactMarkdown from 'react-markdown'
import {
  SET_FEDERAL_POLL_MAP } from '../../../../redux/actions'

const FederalPollMap = ({match, props}) => {

  let amatch = useRouteMatch("/political/canada/federal/election/:year/:local_division");
  var mapset = 0;
  const darkMode = useSelector(state => state.starter.darkMode)
  var query, query1, query2, query3, variables, variables1, variables2, variables3;
  const dispatch = useDispatch()

  const testRiding = (a) => {
    if (a != null && a.getRidingInfo != null && a.getRidingInfo.general_info != null) {
      setRidingInfo(decodeURIComponent(a.getRidingInfo.general_info))
    }
  }

  query2 = GET_ALL_RELATED_CONTESTS
  variables2 = { event_type:'Federal', event: 'Election', district: 'Canada' }

  if (amatch !== null) {
    query = GET_ONE_FEDERAL_POLL_MAP
    variables = { year: match.params.year, local_division: amatch.params.local_division }

    query1 = GET_ONE_CANADIAN_ELECTION_CANDIDATES
    variables1 = { year: match.params.year, event_type:'Federal', local_division: match.params.local_division }
    
    query3 = GET_ONE_RIDING_INFO
    variables3 = { year: match.params.year, event_type:'Federal', local_division: match.params.local_division, event:'Election', major_jurisdiction:'Canada' }

  } else {
    query = GET_ONE_FEDERAL_ELECTION_MAP
    variables = { year: match.params.year }

    query1 = GET_ONE_CANADIAN_ELECTION
    variables1 =  { year: match.params.year, event_type:'Federal', minor_jurisdiction:'Canada'}

    query3 = GET_ONE_RIDING_INFO
    variables3 = { year: match.params.year, event_type:'Federal', local_division: "x", event:'Election', major_jurisdiction:'Canada' }

  }

  //var poll_map;
  //dispatch({type: SET_FEDERAL_POLL_MAP, yearDivision: match.params.year+''+match.params.local_division})
  //var poll_map = useSelector(state => state.starter.pollMap)
  const mapCount = useSelector(state => state.starter.mapCount)
  const pollMapLocalDivision = useSelector(state => state.federalPollMap.pollMapLocalDivision)

  const [skip, setSkip] = useState(false);
  const [intro, setIntro] = useState('');
  const [poll_map, setPollMap] = useState(null);
  let [mapType, setMapType] = useState('national')
  let [updateMapYearDiv, setUpdateMapYearDiv] = useState('');
  let [contestControlList, setContestControlList] = useState([]);
  let [ridingInfo, setRidingInfo] = useState(null);

  const { loading, error, data } = useQuery(query, {onCompleted: setSkip,
    variables: variables
  });

  const { loading1, error1, data1 } = useQuery(query1, {onCompleted: setIntro,
    variables: variables1,
    fetchPolicy:"network-only"
  });    

  const { loading4, error4, data4 } = useQuery(query3, {onCompleted: testRiding,
    variables: variables3,
    fetchPolicy:"network-only"
  });

  const { loading2, error2, data2 } = useQuery(query2, {onCompleted: setContestControlList,
    variables: variables2,
    fetchPolicy:"network-only"
  });      

  const [doIntroUpdate, { loading7, error7, data7 }] = useLazyQuery(query1);
  const [doDetailsUpdate, { loading3, error3, data3 }] = useLazyQuery(query1);
  const [doInfoUpdate, { loading5, error5, data5 }] = useLazyQuery(query3);

  const [doBroadToLocalIntroUpdate, { loading8, error8, data8 }] = useLazyQuery(GET_ONE_CANADIAN_ELECTION_CANDIDATES);
  const [doBroadToLocalDetailsUpdate, { loading9, error9, data9 }] = useLazyQuery(GET_ONE_CANADIAN_ELECTION_CANDIDATES);
  const [doBroadToLocalInfoUpdate, { loading10, error10, data10 }] = useLazyQuery(GET_ONE_RIDING_INFO);

const doEcho = (a) => {
  console.log(a)
}

  const doUpdate = (a) => {
    if (a.hasOwnProperty('goBroad')) {
      goToFederal(a.year)
      return;
    }
    doDetailsUpdate({
      onCompleted: setIntro,
      variables: { 
        year: a.year, 
        minor_jurisdiction:a.minor_jurisdiction, 
        event_type:'Federal', 
        local_division: a['Riding ID'].toString()
      }
    });
    
    doInfoUpdate({
      onCompleted: testRiding,
      variables: { 
        year: a.year, 
        event_type:'Federal', 
        local_division: a['Riding ID'].toString(),
        event:'Election', 
        major_jurisdiction:'Canada' 
      }
    });
    var new_poll_map = {};
    if (a.hasOwnProperty('Election Type') && a['Election Type'] === 'Federal') {
      new_poll_map = Object.assign(new_poll_map, a);
      new_poll_map.center = JSON.parse(new_poll_map['Center'])
      new_poll_map.bounds = JSON.parse(new_poll_map['Bounds'])
      new_poll_map.local_division = new_poll_map['Riding ID']
      new_poll_map.event_type = new_poll_map['Election Type']
      new_poll_map.district = new_poll_map['Riding Name']
      new_poll_map.category = new_poll_map['political']
      dispatch({type: SET_FEDERAL_POLL_MAP, yearDivision: new_poll_map.year+new_poll_map.local_division})
      console.log(new_poll_map)

      // dispatch({type: SET_POLL_MAP, pollMap: new_poll_map})
      // dispatch({type: SET_MAP_SELECTED, mapSelected: new_poll_map})
      // dispatch({type: SET_SEARCH_RESULTS, searchResults: false})
      // dispatch({type: SET_POLL_MAP_YEAR, pollMapYear: new_poll_map.year})
      // dispatch({type: SET_POLL_MAP_LOCAL_DIVISION, pollMapLocalDivision: new_poll_map.local_division})
      // dispatch({type: SET_MAP_COUNT, mapCount: mapCount+1})

      setPollMap(new_poll_map)
      setMapType('poll')
      window.history.replaceState(null, new_poll_map.title, '/data/political/canada/federal/election/'+new_poll_map.year+'/'+new_poll_map.local_division)
      //routerHistory.push('/political/canada/federal/election/'+new_poll_map.year+'/'+new_poll_map.local_division)
      //return (<Redirect push to={'/political/canada/federal/election/'+new_poll_map.year+'/'+new_poll_map.local_division} />)
    }

  }

  const doBroadToLocalUpdate = (a) => {
    if (a.hasOwnProperty('goBroad')) {
      goToFederal(a.year)
      return;
    }

    doBroadToLocalDetailsUpdate({
      onCompleted: setIntro,
      variables: { 
        year: a.year, 
        minor_jurisdiction:a.minor_jurisdiction, 
        event_type:'Federal', 
        local_division: a['Riding ID'].toString()
      }
    });
    
    doBroadToLocalInfoUpdate({
      onCompleted: testRiding,
      variables: { 
        year: a.year, 
        event_type:'Federal', 
        local_division: a['Riding ID'].toString(),
        event:'Election', 
        major_jurisdiction:'Canada' 
      }
    });
    var new_poll_map = {};
    if (a.hasOwnProperty('Election Type') && a['Election Type'] === 'Federal') {
      new_poll_map = Object.assign(new_poll_map, a);
      new_poll_map.center = JSON.parse(new_poll_map['Center'])
      new_poll_map.bounds = JSON.parse(new_poll_map['Bounds'])
      new_poll_map.local_division = new_poll_map['Riding ID']
      new_poll_map.event_type = new_poll_map['Election Type']
      new_poll_map.district = new_poll_map['Riding Name']
      new_poll_map.category = new_poll_map['political']
      dispatch({type: SET_FEDERAL_POLL_MAP, yearDivision: new_poll_map.year+new_poll_map.local_division})
      console.log(new_poll_map)

      setPollMap(new_poll_map)
      setMapType('poll')
      window.history.replaceState(null, new_poll_map.title, '/data/political/canada/federal/election/'+new_poll_map.year+'/'+new_poll_map.local_division)
    }

  }

  useEffect(() => {
    console.log("RRRRRRDDSAFSDF")
    console.log(match.params)
    console.log(match.params.local_division)
    console.log(poll_map)
    if (poll_map && poll_map.local_division != null) {
      var mapObj = {};
      mapObj.year = poll_map.year;
      mapObj.minor_jurisdiction = 'Canada';
      mapObj.event_type = 'Federal';
      mapObj.local_division = poll_map.local_division;
      mapObj.major_jurisdiction = 'Canada';
      mapObj['Riding ID'] = poll_map.local_division;
      console.log("$$$$$$$")
      doBroadToLocalUpdate(mapObj);
    }
  }, [poll_map, match.params.year, match.params.local_division])

  

  if (data && data.getCanadianFederalElection) {
    activeMap(data.getCanadianFederalElection)
    mapset = 1
  }

  if (data && data.getFederalPollMap) {
    activeMap(data.getFederalPollMap)
    mapset = 1
  }  

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" }
    return new Date(dateString).toLocaleDateString(undefined, options)
  }

  var others = "";
  var otherscopy = [];
  if (intro && intro.getCanadianElectionRidingDetails) {
    otherscopy = [...intro.getCanadianElectionRidingDetails.candidates];
    others = otherscopy
      .splice(2,)
      .filter(c => c.candidate_percent_of_vote > 5)
      .map((selectedcandidate,i,cs) => { 
        if (i===cs.length-1 && cs.length > 1) { 
          return(` and ${selectedcandidate.candidate_name} - ${selectedcandidate.candidate_party} (${selectedcandidate.candidate_percent_of_vote}%)`)
        } else { 
          return( ` ${selectedcandidate.candidate_name} - ${selectedcandidate.candidate_party} (${selectedcandidate.candidate_percent_of_vote}%)`) 
        }
      });
  }  

  useEffect(() => {
    console.log("#")
    console.log(data)
    if (data != 'undefined' && data && data.getFederalPollMap) {
      //if (!skip) {
        console.log(data)
        activeMap(data.getFederalPollMap)
        console.log(data.getFederalPollMap)
        console.log("YYYYYYY")
        setPollMap(data.getFederalPollMap);
        setMapType('poll')
        console.log(data.getFederalPollMap);
        //dispatch({type: SET_POLL_MAP, pollMap: pmap})
        //poll_map = pmap
    //}
    } else if (data != 'undefined' && data && data.getCanadianFederalElection) {
      activeMap(data.getCanadianFederalElection)
      console.log(data.getCanadianFederalElection)
      console.log("ZZZZZZZZ")
      setPollMap(data.getCanadianFederalElection);
      setMapType('national')
    }


  }, [data, mapCount, pollMapLocalDivision])
  
  useEffect(() => {
    if (data1 != undefined && data1 && data1.getCanadianElectionRidingDetails) {
      console.log("%%%%%%")
      setIntro(data1.getCanadianElectionRidingDetails)
    }
    if (data4 != undefined && data4 && data4 ) {
      console.log(data4);
        //testRiding(data4.getCanadianElectionRidingDetails)
    }
  }, [data1, mapCount, pollMapLocalDivision, data4])

  useEffect(() => {
    if (data2 != undefined && data2 && data2.getAllRelatedContests) {
      console.log(data.getAllRelatedContests);
      setContestControlList(data2.getAllRelatedContests)
    } else {
      console.log(data2)
    }
  }, [data2])  

  const goToFederal = (year) => {
    if (contestControlList != null && contestControlList.getAllRelatedContests != null && contestControlList.getAllRelatedContests.length > 0) {
      var arraySearchResult = contestControlList.getAllRelatedContests.find(n => n.year == year);
      console.log(arraySearchResult);
      var new_poll_map = {};
      if (arraySearchResult.hasOwnProperty('geojson_url')) {
        new_poll_map = Object.assign(new_poll_map, arraySearchResult);
        console.log(new_poll_map)
        dispatch({type: SET_FEDERAL_POLL_MAP, yearDivision: new_poll_map.year})
        console.log(new_poll_map)
        if (!new_poll_map.hasOwnProperty("title") && new_poll_map.hasOwnProperty("event_type") && new_poll_map.event_type == 'Federal' && new_poll_map.hasOwnProperty('minor_jurisdiction') && new_poll_map.hasOwnProperty('minor_jurisdiction')) {
          new_poll_map.title = new_poll_map.year+ ' Canadian ' +new_poll_map.event_type + ' ' +new_poll_map.event + ' Map'
        }        
        setPollMap(new_poll_map)
        setMapType('national')
        window.history.replaceState(null, new_poll_map.title, '/data/political/canada/federal/election/'+new_poll_map.year)
      }  
    }
    //history.push('/political/canada/federal/election/'+year);
  }

  return (
      <div>
        <Helmet>
                <meta charSet="utf-8" />
                <title>{poll_map ? poll_map.title : ''}</title>
                <link rel="canonical" href={poll_map ? "https://www.stephentaylor.ca/data/political/canada/federal/election/"+poll_map.year+"/"+poll_map.local_division+"/": ""} />
                <meta property="og:type"               content="article" />
                <meta property="og:url"                content={poll_map ? "https://www.stephentaylor.ca/data/political/canada/federal/election/"+poll_map.year+"/"+poll_map.local_division+"": ""} />
                <meta property="og:title"              content={poll_map ? poll_map.title : ''} />
                <meta property="og:description"        content="Stephen Taylor Data - Useful data and analysis for politics, democracy, health, and commerce" />
                <meta property="og:image"              content={poll_map ? "https://geojson-maps.s3.amazonaws.com/images/"+poll_map.year+"-"+poll_map.local_division+"-preview.png" : "https://www.stephentaylor.ca/wp-content/uploads/2021/09/pollmap.png"} />                
                <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <CRow>
        {poll_map && poll_map.hasOwnProperty('year') ? 
          <TheAside 
            et={poll_map.event_type} 
            minj={poll_map.minor_jurisdiction} 
            majj={poll_map.major_jurisdiction} 
            year={poll_map.year} 
            ld={poll_map.local_division} 
            lng={poll_map.center[0]} 
            lat={poll_map.center[1]}  
          /> 
        : 
          <></> 
        }
        <CCol xs="12" sm="12" md="12">
        <CCard>
        <CCardHeader>
        <h3>{poll_map ? poll_map.title : ''} {' '}</h3>
          
          <div className="card-header-actions">
            <a href="https://elections.ca" rel="noreferrer noopener" target="_blank" className="card-header-action">
              <small className="text-muted">Election results data</small>
            </a>
          </div>
        </CCardHeader>
        <CCardBody>
        {/* { poll_map && data ? <Map key={[darkMode, poll_map]} data={poll_map} /> : <></>} */}
        <MapGL data={poll_map} updateMap={doUpdate} />
      </CCardBody>
      <CCardBody style={{whiteSpace:'pre-line'}}>

        { poll_map !== null && data !== null && (poll_map.hasOwnProperty('minor_jurisdiction') && poll_map.minor_jurisdiction !== 'Canada') && intro.hasOwnProperty('getCanadianElectionRidingDetails') ? `📌 The Canadian federal electoral district of ${poll_map.district} was contested during the ${poll_map.year} ${poll_map.event_type} election which was held on ${formatDate(intro.getCanadianElectionRidingDetails.candidates[0].contest_date/1)}. 
        
        🏆 ${intro.getCanadianElectionRidingDetails.candidates[0].candidate_name}, the ${intro.getCanadianElectionRidingDetails.candidates[0].candidate_party} candidate, won the riding with ${intro.getCanadianElectionRidingDetails.candidates[0].candidate_votes} votes making up a ${intro.getCanadianElectionRidingDetails.candidates[0].candidate_percent_of_vote}% share of the vote.

        🥈 The runner-up ${intro.getCanadianElectionRidingDetails.candidates[1].candidate_party} candidate, ${intro.getCanadianElectionRidingDetails.candidates[1].candidate_name}, received ${intro.getCanadianElectionRidingDetails.candidates[1].candidate_votes} votes (${intro.getCanadianElectionRidingDetails.candidates[1].candidate_percent_of_vote}%) and was therefore defeated by a vote margin of ${intro.getCanadianElectionRidingDetails.candidates[0].candidate_votes - intro.getCanadianElectionRidingDetails.candidates[1].candidate_votes}.
        
        📊 Other candidates who received a sizable share of the vote include ${others}.
        ` : "" }
      </CCardBody>      
      </CCard>
      </CCol>
      </CRow>
      { poll_map !== null && data !== null && (poll_map.hasOwnProperty('minor_jurisdiction') && poll_map.minor_jurisdiction !== 'Canada') && intro.hasOwnProperty('getCanadianElectionRidingDetails')  && ridingInfo != null ?
        <CRow key={mapCount}>
          <CCol xs="12" sm="12" md="12">
            <CCard>
              <CCardHeader>Riding information<span className="float-right" style={{fontSize:'8pt'}}>Auto generated. <a href="mailto:email@stephentaylor.ca">Flag an issue</a>.</span> </CCardHeader>
              <CCardBody>
                { ridingInfo != null ? <ReactMarkdown>{ridingInfo}</ReactMarkdown> : <></>}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
        : <></> 
      }
      { poll_map && (poll_map.year === "2021" || poll_map.year === "2019" || poll_map.year === "2015") && (poll_map.hasOwnProperty('minor_jurisdiction') && poll_map.minor_jurisdiction !== 'Canada') ? 
      <CRow>
        <CCol xs="12" sm="6" md="6">
          <CCard>
            <CCardHeader>Population distribution by age and sex
            <div className="card-header-actions">
            <a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/index-eng.cfm" rel="noreferrer noopener" target="_blank" className="card-header-action">
              <small className="text-muted">2016 census data</small>
            </a>
            </div>
            </CCardHeader>
            <CCardBody>
              {mapType && mapType == 'poll' && pollMapLocalDivision ? <PopulationPyramid key={mapCount} ld={poll_map.local_division} /> : <></> }
            </CCardBody>
          </CCard>
          </CCol>
          <CCol xs="12" sm="6" md="6">
          <CCard>
            <CCardHeader>Residence data
            <div className="card-header-actions">
            <a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/index-eng.cfm" rel="noreferrer noopener" target="_blank" className="card-header-action">
              <small className="text-muted">2016 census data</small>
            </a>
            </div>
            </CCardHeader>
            <CCardBody>
              {pollMapLocalDivision ? <ResidencePie key={mapCount} ld={poll_map.local_division} /> : <></> }
            </CCardBody>
          </CCard>          
        </CCol>
        <CCol xs="12" sm="12" md="12">
          <CCard>
            <CCardHeader>Income Graph
            <div className="card-header-actions">
            <a href="https://www12.statcan.gc.ca/census-recensement/2016/dp-pd/index-eng.cfm" rel="noreferrer noopener" target="_blank" className="card-header-action">
              <small className="text-muted">2016 census data</small>
            </a>
            </div>              
            </CCardHeader>
            <CCardBody>
              { poll_map.local_division ? <WealthGraph key={mapCount} ld={poll_map.local_division} /> : <></> }
            </CCardBody>
          </CCard>
        </CCol>
      </CRow> : <></> }
      <CRow>
        <CCol xs="12" sm="12" md="12">
        { poll_map && poll_map.hasOwnProperty('year') && poll_map.hasOwnProperty('minor_jurisdiction') && poll_map.minor_jurisdiction !== 'Canada' ? 
          <NearbyMaps         
              et={poll_map.event_type} 
              minj={poll_map.minor_jurisdiction} 
              majj={poll_map.major_jurisdiction} 
              year={poll_map.year} 
              ld={poll_map.local_division} 
              lng={poll_map.center[0]} 
              lat={poll_map.center[1]} 
          />
          : 
              <></>
          }
          </CCol>    
        </CRow>  
      </div>
    )
  }
  
  export default FederalPollMap;